export default __webpack_public_path__ + "static/media/edit.396f3dae.svg";